module.exports = new __parcel__URL__("mutter.e2d733cf.jpg").toString();